export function logFn(name) {
  var _console;

  /* eslint-disable no-console */
  console.groupCollapsed("[@gandi/tracking]: ".concat(name));

  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  (_console = console).log.apply(_console, args);

  console.groupEnd();
  /* eslint-enable no-console */
}